module.exports = __webpack_public_path__ + "static/no-webcam-filler-f7fd9ccbed8deba38527a43adc49528f.jpg";